<template>
  <div>
    <h1>Relatorio de Oportunidades</h1>
    <b-card>
      <FormOportunidades />
    </b-card>
  </div>
</template>

<script>
import FormOportunidades from "../Components/FormOportunidades.vue";

export default {
  components: { FormOportunidades },
};
</script>

<style></style>
